class comparisonChart extends HTMLElement {
  constructor() {
    super();
    this.productInputs = this.querySelectorAll('input[name^="compare_chart"]');
  }
  connectedCallback() {
    this.init();
    if (Shopify.designMode) {
      this.querySelector('[data-compare-loader]')?.remove();
      return;
    }
    if (!localStorage.getItem('_comparision_chart_products')) {
      this.querySelector('[data-compare-loader]')?.remove(); 
    } else {
      this.setCartAttribute(localStorage.getItem('_comparision_chart_products'));
    }
  }

  init() {
    this.productInputs?.forEach(input => {
      input.addEventListener('change', this.handleChange.bind(this));
    });

    this.querySelectorAll('li.form-check').forEach(li => {
      li.addEventListener('click', (e) => {
        const input = li.querySelector('input[data-compare-chart-product]');
        if (!input || input.checked) return;
        if (e.target.tagName === 'LABEL' || e.target.tagName === 'INPUT') return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    this.stickyCompareHeader();
    this.highlightCurrentProduct();
  }

  handleChange(e) {
    e.preventDefault();
    const handles = ['', '', ''];
    Array.from(this.productInputs)
      .filter(input => input.checked)
      .forEach(input => {
        const idx = parseInt(input.dataset.index, 10);
        if (!Number.isNaN(idx) && idx >= 0 && idx < handles.length) {
          handles[idx] = input.value;
        }
      });
    this.setLocalStorage(handles.join(','));
  }

  renderData = async () => {
    fetch(`${location.origin}${location.pathname}?section_id=${this.dataset.sectionId}`)
    .then(res => res.text())
    .then(data => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const sourceQty = html.querySelector('comparison-chart');
      this.innerHTML = sourceQty.innerHTML;
      
      this.productInputs = this.querySelectorAll('input[name^="compare_chart"]');
      this.querySelector('[data-compare-loader]')?.remove();
      this.init();

      this.removeCartAttribute();
    });
  }

  setLocalStorage(productHandle) {
    localStorage.setItem('_comparision_chart_products', productHandle); 
    this.productHandles = productHandle;
    this.setCartAttribute(productHandle);
  }

  setCartAttribute = async (productHandle) => {
    if (productHandle) {
      let body = {attributes: {'_comparision_chart_products': productHandle}};
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
      })
      .then(response => {
        this.renderData();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  removeCartAttribute() {
    let body = { attributes: {} };
    body.attributes['_comparision_chart_products'] = null;
  
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .catch((error) => console.error('Error:', error));
  }

  highlightCurrentProduct() {
    const currentProductHandle = localStorage.getItem('_comparision_chart_product_current');
    const comparisonProducts = localStorage.getItem('_comparision_chart_products');
    
    if (currentProductHandle && comparisonProducts) {
      const comparisonProductArray = comparisonProducts.split(',').map(handle => handle.trim());
      
      if (comparisonProductArray.includes(currentProductHandle)) {
        // Find the index of the current product in the comparison array
        const currentIndex = comparisonProductArray.indexOf(currentProductHandle);
        
        // Get all product row table cells
        const productRowCells = this.querySelectorAll('.product-row td');
        
        // Add 'current' class to the corresponding cell
        if (productRowCells[currentIndex]) {
          productRowCells[currentIndex].classList.add('current');
        }
      }
    }
  }

  stickyCompareHeader() {

    let header = document.querySelector('.section-header'); 
    let isScrolling; // Timer for debounce
    window.addEventListener('load', () => {
      this.style.setProperty('--top-position', `${(this.getBoundingClientRect().top * -1) + header.clientHeight}px`);
      window.addEventListener('scroll', () => {
        this.classList.remove('is-sticky-active');
        clearTimeout(isScrolling);
        
          if(this.getBoundingClientRect().top < 0) {
            this.classList.add('is-sticky');
            isScrolling = setTimeout(() => {
              this.classList.add('is-sticky-active');
              this.style.setProperty('--top-position', `${(this.getBoundingClientRect().top * -1) + header.clientHeight}px`);
            },100);
          } else {
            this.classList.remove('is-sticky');
            this.classList.remove('is-sticky-active');
            this.style.setProperty('--top-position', `0`);
          }

      });
    })
  }
}
customElements.define('comparison-chart', comparisonChart);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const chart = e.target.querySelector('comparison-chart');
    if (!chart) return;

    fetch(`${location.origin}${location.pathname}?section_id=${chart.dataset.sectionId}`)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('comparison-chart');
        if (!fresh) return;
        chart.innerHTML = fresh.innerHTML;
        chart.productInputs = chart.querySelectorAll('input[name^="compare_chart"]');
        chart.querySelector('[data-compare-loader]')?.remove();
        chart.init();
      })
      .catch(() => {});
  });
}